import React from 'react';
import { useState, useCallback, useMemo } from 'react';
import { Button, Form } from 'react-bootstrap';
import claimEmployeesService from '../../services/claim/claim_employees.service';
import { ChangeHighlighter } from '@rd-web-markets/shared/dist/util/ChangeHighlighter';
import { handleError } from '@rd-web-markets/shared/dist/store/features/alertSlice';
import { useDispatch } from 'react-redux';
export const EmployeeBioRow = _ref => {
  let {
    index,
    claim,
    handleAdd,
    handleDelete,
    claimEmployees,
    setClaimEmployees
  } = _ref;
  const claimEmployee = useMemo(() => {
    return {
      ...claimEmployees[index]
    };
  }, [claimEmployees, index]);
  const [hasError, setHasError] = useState(false);
  const dispatch = useDispatch();
  const updateEmployees = useCallback(employee => {
    const newEmployees = [...claimEmployees];
    newEmployees[index] = {
      ...employee
    };
    setClaimEmployees([...newEmployees]);
  }, [claimEmployees, index, setClaimEmployees]);
  const confirmAndDelete = async index => {
    if (window.confirm('Are you sure you wish to delete this employee?')) {
      try {
        await handleDelete(index);
      } catch (error) {
        dispatch(handleError(error));
      }
    }
  };
  const handleChange = useCallback(async event => {
    const value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
    claimEmployee[event.target.name] = value;
    await updateEmployees(claimEmployee);
  }, [updateEmployees, claimEmployee]);
  const saveChange = useCallback(() => {
    let method;
    if (claimEmployee.id) {
      method = 'update';
    } else {
      method = 'create';
    }
    claimEmployeesService[method](claimEmployee).then(updatedEmployee => {
      updateEmployees(updatedEmployee);
      setHasError(false);
    }).catch(e => {
      setHasError(true);
      dispatch(handleError(e));
    });
  }, [updateEmployees, claimEmployee, dispatch]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("tr", {
    className: hasError ? 'bg-warning' : ''
  }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ChangeHighlighter, {
    as: Form.Control,
    onChange: e => handleChange(e, index),
    onBlur: saveChange,
    object: {
      ...claimEmployee,
      claim: {
        ...claim,
        ...claimEmployee.claim
      }
    },
    disabled: claim.financials_locked,
    name: "name",
    type: "text",
    className: "mb-3",
    placeholder: "Please enter employees name",
    size: "sm"
  }), /*#__PURE__*/React.createElement(ChangeHighlighter, {
    as: Form.Control,
    onChange: e => handleChange(e, index),
    onBlur: saveChange,
    object: {
      ...claimEmployee,
      claim: {
        ...claim,
        ...claimEmployee.claim
      }
    },
    disabled: claim.financials_locked,
    name: "number",
    type: "text",
    placeholder: "Please enter employees number",
    className: "mb-3",
    size: "sm"
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ChangeHighlighter, {
    as: Form.Control,
    onChange: e => handleChange(e, index),
    onBlur: saveChange,
    object: {
      ...claimEmployee,
      claim: {
        ...claim,
        ...claimEmployee.claim
      }
    },
    disabled: claim.financials_locked,
    name: "bio",
    placeholder: "Please enter employees experience and relevant qualifications",
    type: "text",
    controlAs: "textarea",
    rows: "5"
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
    className: "d-flex"
  }, /*#__PURE__*/React.createElement(ChangeHighlighter, {
    as: Form.Check,
    object: {
      ...claimEmployee,
      claim: {
        ...claim,
        ...claimEmployee.claim
      }
    },
    name: "include_in_technical_report",
    onChange: async e => {
      await handleChange(e, index);
      saveChange();
    },
    label: "Include within R&D Report",
    className: "mb-1 col-form-label",
    size: "sm"
  }), /*#__PURE__*/React.createElement(Button, {
    variant: "secondary",
    disabled: claim.is_locked || claim.financials_locked || claim.active_change_set,
    onClick: () => confirmAndDelete(index)
  }, /*#__PURE__*/React.createElement("span", {
    className: "material-icons text-danger"
  }, "delete"))))));
};